import React, { useState, useEffect } from "react";
import Select from "react-select";

const Fselect = ({
  type,
  title,
  isSearchable = false,
  placeholder = "",
  errorMessage = "",
  onChange = () => {},
  options = [],
  value = undefined,
  arrowIcon = true,
  menuIsOpen = false,
  onKeyDown = () => {},
  onKeyUp = () => {},
}) => {
  switch (type) {
    case "SelectIcon":
      return (
        <FSelectIcon
          title={title}
          isSearchable={isSearchable}
          placeholder={placeholder}
          options={options}
          onChange={onChange}
          value={value}
          errorMessage={errorMessage}
          arrowIcon={arrowIcon}
          menuIsOpen={menuIsOpen}
          onKeyDown={onKeyDown}
          onKeyUp={onKeyUp}
        />
      );
    default:
      return (
        <FSelect
          title={title}
          isSearchable={isSearchable}
          placeholder={placeholder}
          options={options}
          onChange={onChange}
          value={value}
          errorMessage={errorMessage}
          arrowIcon={arrowIcon}
          menuIsOpen={menuIsOpen}
          onKeyDown={onKeyDown}
          onKeyUp={onKeyUp}
        />
      );
  }
};

const FSelect = ({
  errorMessage,
  isSearchable,
  placeholder,
  title,
  onChange = () => {},
  options = [],
  value,
  arrowIcon,
  menuIsOpen,
  onKeyDown,
  onKeyUp,
}) => {
  let [widthScreem2, setwidthScreem2] = useState(window.innerWidth);
  let widthScreem = window.innerWidth;
  window.addEventListener("resize", function () {
    widthScreem = window.innerWidth;
    setwidthScreem2(widthScreem);
  });

  let _value = value;
  let [selected, setSelected] = useState(_value);
  useEffect(() => {
    setSelected(_value);
  }, [_value]);
  return (
    <div className="border-0 w-full pt-2">
      <div className="font-bold text-[4.5vw] xxs:text-[14px] pb-1">{title}</div>
      <Select
        menuIsOpen={menuIsOpen}
        placeholder={placeholder}
        styles={{
          dropdownIndicator: (defaultStyles) => ({
            ...defaultStyles,
            "& svg": { display: arrowIcon ? "block" : "none" },
          }),
          indicatorSeparator: arrowIcon ? null : () => {},
          control: (base, state) => ({
            ...base,
            height: widthScreem2 > 330 ? "64px" : "54px",
            fontWeight: "regular",
            backgroundColor: "#f6f6f6",
            borderRadius: "12px",
            paddingLeft: "7px",
            fontSize: widthScreem2 > 330 ? "16px" : "4vw",
          }),
        }}
        isSearchable={isSearchable}
        classNamePrefix="bg-[red]"
        options={options}
        value={selected}
        onInputChange={onKeyUp}
        onKeyDown={onKeyDown}
        onChange={(e) => {
          _value = e;
          setSelected(e);
          onChange(e);
        }}
        getOptionLabel={(e) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            <span style={{ marginLeft: 5 }}>{e.value}</span>
          </div>
        )}
      />
      <p className="text-error font-bold text-left text-small">
        {errorMessage}
      </p>
    </div>
  );
};

const FSelectIcon = ({
  errorMessage,
  isSearchable,
  placeholder,
  title,
  onChange = () => {},
  options = [],
  value,
  arrowIcon,
  menuIsOpen,
  onKeyDown,
  onKeyUp,
}) => {
  let [widthScreem2, setwidthScreem2] = useState(window.innerWidth);
  let widthScreem = window.innerWidth;
  window.addEventListener("resize", function () {
    widthScreem = window.innerWidth;
    setwidthScreem2(widthScreem);
  });

  let _value = value;
  useEffect(() => {
    setSelected(value);
  }, [value]);

  let [selected, setSelected] = useState(_value);
  useEffect(() => {
    setSelected(_value);
  }, [_value]);
  return (
    <div className="border-0 w-full pt-2">
      <div className="font-bold text-[4.5vw] xxs:text-[14px] pb-1">{title}</div>
      <Select
        menuIsOpen={!menuIsOpen ? undefined : menuIsOpen}
        placeholder={placeholder}
        styles={{
          menu: (defaultStyles) => ({
            ...defaultStyles,
            zIndex: 50,
          }),
          dropdownIndicator: (defaultStyles) => ({
            ...defaultStyles,
            "& svg": { display: arrowIcon ? "block" : "none" },
          }),
          indicatorSeparator: arrowIcon ? null : () => {},
          control: (base, state) => ({
            ...base,
            zIndex: 10,
            height: widthScreem2 > 330 ? "64px" : "54px",
            fontWeight: "regular",
            backgroundColor: "#f6f6f6",
            borderRadius: "12px",
            paddingLeft: "7px",
            fontSize: widthScreem2 > 330 ? "16px" : "4vw",
          }),
        }}
        isSearchable={isSearchable}
        options={options}
        value={selected}
        onInputChange={onKeyUp}
        onKeyDown={onKeyDown}
        onChange={(e) => {
          _value = e;
          setSelected(e);
          onChange(e);
        }}
        getOptionLabel={(e) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            {e.ico == null ? null : (
              <img src={e.ico} className="h-[18px] xxs:h-[23px]" />
            )}
            &nbsp;
            <span style={{ marginLeft: 5 }}>{e.value}</span>
          </div>
        )}
      />
      <p className="text-error font-bold text-left text-small">
        {errorMessage}
      </p>
    </div>
  );
};

export default Fselect;
